import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getProductosGenericosBocetos,
  insertProductosGenericosBocetos,
  updateProductosGenericosBocetos,
  updateProductosGenericosBocetosPosicion,
  deleteProductosGenericosBocetos,
  getProductosGenericosBocetosById,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PRODUCTOS_GENERICOS_BOCETOS(action) {
  try {
    const productoGenericoBoceto = yield call(getProductosGenericosBocetos, action.payload)
    if (productoGenericoBoceto.ok) {
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_LOAD_SUCCEEDED,
        payload: productoGenericoBoceto.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Productos Genericos Bocetos')
      put({
        type: actions.PRODUCTO_GENERICO_BOCETO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_BOCETO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PRODUCTO_GENERICO_BOCETO(action) {
  try {
    const productoGenericoBoceto = yield call(getProductosGenericosBocetosById, action.id)
    if (productoGenericoBoceto.ok) {
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_LOAD_SUCCEEDED,
        payload: productoGenericoBoceto.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Productos Genericos Bocetos')
      put({
        type: actions.PRODUCTO_GENERICO_BOCETO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_BOCETO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_PRODUCTO_GENERICO_BOCETO(action) {
  try {
    const productoGenericoBoceto = yield call(insertProductosGenericosBocetos, action.payload)
    if (productoGenericoBoceto.ok) {
      putMessage(messageType.SUCCESS, 'Producto Generico Boceto creado correctamente')
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_INSERT_SUCCEEDED,
        payload: productoGenericoBoceto.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Producto Generico Boceto')
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Producto Generico Boceto')
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_BOCETO_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PRODUCTO_GENERICO_BOCETO(action) {
  try {
    const productoGenericoBoceto = yield call(updateProductosGenericosBocetos, action.payload)
    if (productoGenericoBoceto.ok) {
      putMessage(messageType.SUCCESS, 'Producto Generico Boceto modificado correctamente')
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_UPDATE_SUCCEEDED,
        payload: productoGenericoBoceto.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Producto Generico Boceto')
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Producto Generico Boceto')
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_BOCETO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PRODUCTO_GENERICO_BOCETO_POSICION(action) {
  try {
    const productoGenericoBoceto = yield call(
      updateProductosGenericosBocetosPosicion,
      action.payload,
    )
    if (productoGenericoBoceto.ok) {
      putMessage(messageType.SUCCESS, 'Producto Generico Boceto Posicion modificado correctamente')
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_SUCCEEDED,
        payload: productoGenericoBoceto.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Producto Generico Boceto Posicion')
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Producto Generico Boceto Posicion')
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_PRODUCTO_GENERICO_BOCETO(action) {
  try {
    const productoGenericoBoceto = yield call(deleteProductosGenericosBocetos, action.id)
    if (productoGenericoBoceto.ok) {
      putMessage(messageType.SUCCESS, 'Producto Generico Boceto eliminado correctamente')
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_DELETE_SUCCEEDED,
        id: action.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Producto Generico Boceto')
      yield put({
        type: actions.PRODUCTO_GENERICO_BOCETO_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Producto Generico Boceto')
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_BOCETO_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PRODUCTO_GENERICO_BOCETO_LOAD_REQUESTED, GET_PRODUCTOS_GENERICOS_BOCETOS),
    takeEvery(actions.PRODUCTO_GENERICO_BOCETO_INSERT_REQUESTED, INSERT_PRODUCTO_GENERICO_BOCETO),
    takeEvery(actions.PRODUCTO_GENERICO_BOCETO_UPDATE_REQUESTED, UPDATE_PRODUCTO_GENERICO_BOCETO),
    takeEvery(
      actions.PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_REQUESTED,
      UPDATE_PRODUCTO_GENERICO_BOCETO_POSICION,
    ),
    takeEvery(actions.PRODUCTO_GENERICO_BOCETO_DELETE_REQUESTED, DELETE_PRODUCTO_GENERICO_BOCETO),
  ])
}
